import { createSelector } from "reselect";
import { RootState } from "../reducers";
import _ from "lodash";

const pagesAccess = (state: RootState) => state.auth.user?.pagesAccess;
const menus = (state: RootState) => state.auth.user?.menus;

export const getElementsRefByPageUrl = (pageUrl: string) =>
  createSelector(
    pagesAccess,
    (pages) => pages && _.find(pages, { pageURL: pageUrl })?.elementRefs
  );

export const getMenus = () => createSelector(menus, (menus) => menus);
export const getPagesAccess = () => createSelector(pagesAccess, (pages) => pages);

export const getSpecialAccessUsernames = (state: RootState) =>
  state.specialAccess.usernames;

export const getSpecialAccessLoaded = (state: RootState) =>
  state.specialAccess.isLoaded;